var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bulk/crown"
  }, /*#__PURE__*/React.createElement("g", {
    id: "crown"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.18 12.6533H4.82001C4.54001 12.6533 4.28667 12.4733 4.19334 12.2133L1.42001 4.44665C1.20001 3.82665 1.90667 3.29999 2.43334 3.67999L5.10001 5.58665C5.45334 5.83999 5.96001 5.68665 6.11334 5.27999L7.37334 1.91999C7.58667 1.33999 8.40667 1.33999 8.62001 1.91999L9.88001 5.27999C10.0333 5.69332 10.5333 5.83999 10.8933 5.58665L13.56 3.67999C14.0933 3.29999 14.7933 3.83332 14.5733 4.44665L11.8 12.2133C11.7133 12.4733 11.46 12.6533 11.18 12.6533Z",
    fill: "#202C4A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M11.3333 14.6667H4.66666C4.39332 14.6667 4.16666 14.44 4.16666 14.1667C4.16666 13.8934 4.39332 13.6667 4.66666 13.6667H11.3333C11.6067 13.6667 11.8333 13.8934 11.8333 14.1667C11.8333 14.44 11.6067 14.6667 11.3333 14.6667Z",
    fill: "#F5B826"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M9.66668 9.83331H6.33334C6.06001 9.83331 5.83334 9.60665 5.83334 9.33331C5.83334 9.05998 6.06001 8.83331 6.33334 8.83331H9.66668C9.94001 8.83331 10.1667 9.05998 10.1667 9.33331C10.1667 9.60665 9.94001 9.83331 9.66668 9.83331Z",
    fill: "#F5B826"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.789091c2f6afa12d0a231d8e72516a82.svg";
export { ForwardRef as ReactComponent };